import React from 'react';
import {
  Grid,
  NewTypography as Typography,
  RoundButton,
  useViewport,
} from '@lamimed/pantheon';
import Image from 'next/legacy/image';

import { MainCallToAction } from 'components/MainCallToAction';
import TextWrapper from 'components/TextWrapper';
import { SectionWrapper } from 'components/wrappers/SectionWrapper';

import { NextSectionButton } from '../NextSectionButton';

import * as S from './styles';

import ChiSiamoHeroImg from '/public/images/illustration/about-us/chi-siamo-illustra-hero.png';

interface SectionProps {
  nextSectionId: string;
}

export const ChiSiamoHero: React.FC<SectionProps> = ({ nextSectionId }) => {
  const { greaterThan } = useViewport();

  return (
    <SectionWrapper backgroundColor="gradient__secondary_diagonal">
      <Grid.Wrapper>
        <MainCallToAction>
          <Image
            src={ChiSiamoHeroImg}
            alt="chi siamo"
            width={greaterThan('tablet') ? 382 : 299}
            height={greaterThan('tablet') ? 256 : 200}
            quality={100}
            placeholder="blur"
          />

          <TextWrapper textAlign="left" noMargin={greaterThan('tablet')}>
            <Typography
              variant="heading_1"
              color="text__light"
              marginBottom="none"
              as="h1"
            >
              Chi Siamo
            </Typography>

            <Typography
              color="text__light"
              marginTop="none"
              marginBottom="small"
            >
              Lami è una start-up innovativa che crede in un ecosistema di
              salute digital first per facilitare l&apos;accesso ai servizi e
              migliorare l&apos;esperienza del paziente, spostando il focus
              dalla cura alla prevenzione
            </Typography>

            <S.Link href="/richiedi-una-demo" passHref>
              <RoundButton expanded>Richiedi una demo</RoundButton>
            </S.Link>
          </TextWrapper>
        </MainCallToAction>
      </Grid.Wrapper>

      <NextSectionButton nextSectionId={nextSectionId} />
    </SectionWrapper>
  );
};
